import { Editable, Selectable } from '@shared';
import { Tier } from '@shared-data';

export class UITier extends Editable(Selectable(Tier)) {}
